<template>
  <div>
    <Header />
    <section
      id="inventory"
      class="py-5"
      style="background-image:url(/assets/images/bg/inventory-bg.jpg); background-position: center center; background-size:cover; background-repeat: no-repeat"
    >
      <!-- <div class="container">
        <div class="row">
          <div class="col-8">
            <div class="py-3">
              <router-link
                to="/"
                class="mx-3 btn btn-black btn-pill btn-sm text-white px-4"
                >Home</router-link
              >
            </div>
          </div>
          <div class="col-4">
            <div class="py-3 text-right">
              <router-link to="login" class="font-weight-bold mx-3"
                >Log in</router-link
              >
              <router-link
                to="signup"
                class="mx-3 btn btn-black btn-pill btn-sm text-white px-4"
                >Sign up</router-link
              >
            </div>
          </div>
        </div>
      </div> -->
      <h3 class="text-center">Inventory Manager</h3>
      <p class="w-50 mx-auto text-center font-weight-bold text-black">
        The inventory management tool gives you the flexibility to plan out all
        of your raw material needs all year round and have them delivered to you
        whenever, wherever and in whatever quantity you desire.
      </p>
    </section>

    <section class="table-section px-3 mt-3">
      <div class="alert alert-info text-center">
        Pick single or multiple dates for delivery and quantity to be delivered
      </div>
      <div class="table-responsive text-center pb-2">
        <table class="table table-bordered table-inventory">
          <thead>
            <tr>
              <th width="6%">Order No</th>
              <th width="20%">Commodity</th>
              <!-- <th width="13%">Grade</th> -->
              <th width="15%">Quantity</th>
              <th width="15%">Total Cost</th>
              <th width="19%">Delivery Schedule</th>
              <th width="20%">Address</th>
              <th width="5%">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              is="InventoryItem"
              v-for="(productItem, product_serial) in forms"
              :key="productItem.id"
              :item="productItem"
              :serial="product_serial"
              @valid="assignValue($event, product_serial)"
              @resetWeight="resetWeight(product_serial)"
              @remove="removeRow"
            ></tr>
            <tr>
              <td colspan="5" class="font-weight-bold text-right pr-3">
                TOTAL:
              </td>
              <td colspan="2" class="font-weight-bold h5">
                {{ total | currency("₦", 0) | placeholder("₦ 0") }}
              </td>
            </tr>
          </tbody>
        </table>

        <div class="text-center w-100">
          <button class="btn btn-pill btn-sm btn-success px-3" @click="addForm">
            + Add More
          </button>
        </div>
      </div>

      <div class="my-4 text-center">
        <p class="mb-0 d-inline-block mr-3">
          <strong>Choose Payment Method</strong>
        </p>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            id="card"
            value="card"
            v-model="paymentType"
          />
          <label class="form-check-label" for="card">
            Card
          </label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            id="transfer"
            value="transfer"
            v-model="paymentType"
          />
          <label class="form-check-label" for="transfer">
            Transfer
          </label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            id="delivery"
            value="delivery"
            v-model="paymentType"
          />
          <label class="form-check-label" for="delivery">
            Pay on Delivery
          </label>
        </div>
      </div>

      <div class="text-center mt-3">
        <button
          class="btn btn-pill btn-dark"
          :class="{ disabled: !is_valid }"
          :disabled="!is_valid"
        >
          Pay
        </button>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
// import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import InventoryItem from "@/components/inventory/InventoryItem";

import { weightMixin } from "@/_mixins";
import { mapGetters } from "vuex";

function dataObject() {
  return {
    date: new Date()
      .toJSON()
      .slice(0, 10)
      .replace(/-/g, "-"),
    grade: "",
    name: "",
    qty: 100,
    weight: "kg",
    price: 0
  };
}
export default {
  name: "Inventory",
  mixins: [weightMixin],
  metaInfo: {
    title: "Quickleap",
    titleTemplate: "%s | Inventory Manager",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: { Footer, Header, InventoryItem },
  computed: {
    ...mapGetters("cart", ["products"]),
    total() {
      return this.forms
        .map(form => form.price)
        .reduce((sum, current) => sum + current, 0);
    }
  },
  data() {
    return {
      forms: [dataObject()],
      is_valid: false,
      test: [],
      paymentType: "card"
    };
  },
  methods: {
    addForm() {
      this.forms.push(dataObject());
      this.test[this.forms.length - 1] = false;
      this.validateInput();
    },
    assignValue(value, index) {
      this.test[index] = value;
      this.validateInput();
    },
    resetWeight(index) {
      this.forms[index].qty = 0;
    },
    removeRow(index) {
      this.forms.splice(index, 1);
      this.validateInput();
    },
    validateInput() {
      const isEqual = (arr, value) => arr.every(item => item === value);
      if (isEqual(this.test, true)) {
        return (this.is_valid = true);
      }
      return (this.is_valid = false);
    }
  }
};
</script>

<style lang="css">
.table-inventory th {
  background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%),
    rgba(107, 113, 108, 0.55);
  padding: 15px 0 5px 10px;
  color: black;
}
table.table.table-inventory td {
  padding: 22px 5px;
  text-align: center;
  vertical-align: middle;
}
</style>
